import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';

const useIsExchangeMemberEnabled = () =>
  useIsFeatureFlagEnabled('enableExchangeMember');

export default useIsExchangeMemberEnabled;
